
import parallel from 'async/parallel'
import 'pages/delivery/delivery-regions.tag'
import 'pages/settings/geotargeting/geotargeting-vars-modal.tag'
import 'pages/settings/geotargeting/geotargeting-addpage-modal.tag'
riot.tag2('geotargeting-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#settings/geotargeting"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.name || \'Добавление контакта\' : item.name || \'Редактирование контакта\'}</div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.name}">\n            <label class="control-label">Наименование</label>\n            <input class="form-control" name="name" value="{item.name}">\n            <div class="help-block">{error.name}</div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.city}">\n            <label class="control-label">Город привязки</label>\n            <div class="input-group">\n              <input class="form-control" value="{item.city}" __readonly="{true}">\n              <div class="input-group-btn">\n                <div class="btn btn-default" onclick="{selectCity}"><i class="fa fa-list text-primary"></i></div>\n                <div class="btn btn-default" onclick="{removeCity}"><i class="fa fa-times text-danger"></i></div>\n              </div>\n            </div>\n            <div class="help-block">{error.city}</div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.address}">\n            <label class="control-label">Адрес</label>\n            <input class="form-control" name="address" value="{item.address}">\n            <div class="help-block">{error.address}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.phone}">\n            <label class="control-label">Телефон</label>\n            <input class="form-control" name="phone" value="{item.phone}">\n            <div class="help-block">{error.phone}</div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.additionalPhones}">\n            <label class="control-label">Доп. телефоны</label>\n            <input class="form-control" name="additionalPhones" value="{item.additionalPhones}">\n            <div class="help-block">{error.additionalPhones}</div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.url}">\n            <label class="control-label">URL домена</label>\n            <input class="form-control" name="url" value="{item.url}">\n            <div class="help-block">{error.url}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Примечание</label>\n            <textarea class="form-control" name="description" rows="5" style="min-width: 100%; max-width: 100%;" value="{item.description}"></textarea>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <catalog-static name="variables" rows="{item.variables}" cols="{variablesCols}" handlers="{variablesHandlers}">\n              <yield to="toolbar"><a class="control-label" href="#settings/seo-variables">SEO переменные</a></yield>\n              <yield to="body">\n                <datatable-cell name="id" style="width: 1%;">{row.id}</datatable-cell>\n                <datatable-cell name="name" style="width: 15%;">{row.name}</datatable-cell>\n                <datatable-cell name="value">\n                  <input class="form-control" value="{row.value}" type="text" oninput="{handlers.changeValue}">\n                </datatable-cell>\n                <datatable-cell name="edit" style="width: 1%;">\n                  <button class="btn btn-default" onclick="{handlers.editVars}" title="Редактор"><i class="fa fa-edit"></i></button>\n                </datatable-cell>\n              </yield>\n            </catalog-static>\n          </div>\n        </div>\n      </div>\n      <div class="row" if="{isPages}">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Список страниц для переопределения<br><br>\n              <button class="btn btn-primary" onclick="{addpage}" type="button"><i class="fa fa-plus"></i> Добавить</button>\n              <button class="btn btn-danger" onclick="{removepage}" title="Удалить" type="button"><i class="fa fa-trash"></i></button>\n            </label>\n            <datatable name="pages" rows="{item.pages}" cols="{pagesCols}" handlers="{pagesHandlers}">\n              <datatable-cell name="page" style="width: 33%;">{row.page}</datatable-cell>\n              <datatable-cell name="altpage" style="width: 33%;">\n                <input class="form-control" value="{row.altpage}" type="text" oninput="{handlers.changeAltPage}">\n              </datatable-cell>\n              <datatable-cell name="skin">\n                <input class="form-control" value="{row.skin}" type="text" oninput="{handlers.changeSkin}">\n              </datatable-cell>\n            </datatable>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-2">\n          <div class="form-group">\n            <label class="control-label">Порядок</label>\n            <input class="form-control" name="sort" min="0" step="1" value="{item.sort}" type="{\'number\'}">\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <div class="checkbox-inline">\n              <label>\n                <input name="isVisible" type="checkbox" __checked="{item.isVisible}">Отображать контакт в магазине\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.mixin('validation');
self.mixin('permissions');
self.mixin('remove');
self.mixin('change');
self.item = {};
self.isPages = false;
self.removepage = 0;
self.pagesCount = 0;

self.variablesCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'value', value: 'Значение' }, { name: '', value: '' }];
self.pagesCols = [{ name: 'page', value: 'Страница сайта' }, { name: 'altpage', value: 'Новая страница' }, { name: 'skin', value: 'Дизайн' }];

self.variablesHandlers = {
    changeValue: function changeValue(e) {
        this.row.value = e.target.value;
    },
    editVars: function editVars(e) {
        var _this = this;
        //this.row.value = e.target.value
        modals.create('geotargeting-vars-modal', {
            type: 'modal-primary',
            item: this.row,
            submit: function submit() {
                this.row = this.item;
                this.modalHide();
                self.update();
            }
        });
    }
};

self.pagesHandlers = {
    changeAltPage: function changeAltPage(e) {
        this.row.altpage = e.target.value;
    },
    changeSkin: function changeSkin(e) {
        this.row.skin = e.target.value;
    }
};

self.isPageName = function (name) {
    for (var i = 0; i < self.item.pages.length; i++) {
        if (self.item.pages[i]['page'] === name) {
            return true;
        }
    }
    return false;
};

self.addpage = function () {
    modals.create('geotargeting-addpage-modal', {
        type: 'modal-primary',
        submit: function submit() {
            if (self.isPageName(this.item.name) == false) {
                self.item.pages.push({ page: this.item.name, altpage: '', skin: '' });
                this.modalHide();
                self.update();
            }
        }
    });
};

observable.on('geotargeting-edit', function (id) {
    self.error = false;
    self.loader = true;
    self.isNew = false;
    self.item = {};
    self.update();

    API.request({
        object: 'GeoTargeting',
        method: 'Info',
        data: { id: id },
        success: function success(response) {
            self.item = response;
            self.isPages = typeof self.item.pages != 'undefined' && self.item.pages != null;
        },
        error: function error() {
            self.item = {};
        },
        complete: function complete() {
            self.loader = false;
            self.update();
        }
    });
});

self.submit = function () {
    var params = self.item;
    self.loader = true;
    self.update();

    API.request({
        object: 'GeoTargeting',
        method: 'Save',
        data: params,
        success: function success(response) {
            self.item = response;
            popups.create({ title: 'Успех!', text: 'Контакт геотаргетинга сохранен!', style: 'popup-success' });
            observable.trigger('geotargeting-reload');
        },
        complete: function complete() {
            self.loader = false;
            self.update();
        }
    });
};

self.rules = {
    name: 'empty',
    phone: {
        required: true,
        rules: [{
            type: 'phone'
        }]
    },
    additionalPhones: {
        required: true,
        rules: [{
            type: 'phone'
        }]
    },
    url: {
        rules: [{
            type: 'url'
        }]
    },
    text: 'empty'
};

self.afterChange = function (e) {
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

observable.on('geotargeting-new', function () {
    self.error = false;
    self.isNew = true;
    self.item = { sort: 0, isVisible: true };
    self.update();
});

self.selectCity = function () {
    modals.create('delivery-regions', {
        type: 'modal-primary',
        item: { idCityTo: self.item.idCity },
        submit: function submit() {
            if (this.tags.idCityTo.value) {
                self.item.idCity = this.tags.idCityTo.value;
                self.item.city = this.tags.idCityTo.filterValue;
            }
            this.modalHide();
            self.update();
        }
    });
};

self.removeCity = function () {
    self.item.idCity = null;
    self.item.city = null;
    self.update();
};

self.reload = function () {
    observable.trigger('geotargeting-edit', self.item.id);
};

self.removepage = function () {
    self.item.pages = self.tags.pages.getUnselectedRows();
    self.update();
};

self.on('updated', function () {
    self.tags.pages.on('row-selected', function (count) {
        self.pagesCount = count;
        self.update();
    });
});
});


// WEBPACK FOOTER //
// ./pages/settings/geotargeting/geotargeting-edit.tag